import axios from "axios";
import { useQuery } from "@tanstack/react-query";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const http = axios.create({ baseURL: API });

export const apiGet = (path, params) => http.get(path, { params }).then((r) => r.data);
export const apiPost = (path, body) => http.post(path, body).then((r) => r.data);
export const apiPatch = (path, body) => http.patch(path, body).then((r) => r.data);
export const apiPut = (path, body) => http.put(path, body).then((r) => r.data);
export const apiDelete = (path) => http.delete(path).then((r) => r.data);

export function useApi(key, path, params) {
  return useQuery({
    queryKey: Array.isArray(key) ? key : [key, params],
    queryFn: () => apiGet(path, params),
  });
}
